export const NR_APP_NAME = 'rcf-cash';
export const NR_HTTP_PERF_KEY = 'cash-http-perf';
export const NR_CASH_MODE_START = 'rcf-cash-mode-start-of-day';
export const NR_CASH_MODE_END = 'rcf-cash-mode-end-of-day';
export const NR_CASH_MODE_END_START = 'rcf-cash-mode-end-of-day-start';
export const NR_CASH_MODE_END_FINISH = 'rcf-cash-mode-end-of-day-finish';
